var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",staticStyle:{"height":"100vh"}},[_c('appHeader'),_c('b-container',{staticClass:"wrapper"},[_c('router-view')],1),_c('appFooter',{staticClass:"d-none d-sm-flex bottom-footer mt-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }